import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Layout from './components/layout/Layout/Layout';
import HomePage from './pages/HomePage/HomePage';
import OurStoryPage from './pages/OurStoryPage/OurStoryPage';
import ContactPage from './pages/ContactPage/ContactPage';
import FAQPage from './pages/FAQPage/FAQPage';
import TeamPage from './pages/TeamPage/TeamPage';
import ServicesPage from './pages/ServicesPage/ServicesPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import { FormDataContext } from 'components/ContactForm/FormDataContext';

import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import { WebsiteControlsProvider } from 'context/WebsiteControlsContext';

function App() {
	const [firstName, setFirstName] = useState<string>("")
	const [lastName, setLastName] = useState<string>("")
	const [email, setEmail] = useState<string>("")
	const [phone, setPhone] = useState<string>("")
	const [address, setAddress] = useState<string>("")
	const [county, setCounty] = useState<string>("")
	const [jobDetails, setJobDetails] = useState<string>("")
	const [referralSource, setReferralSource] = useState<string>("")
	const [referralSourceOther, setReferralSourceOther] = useState<string>("")
	const [subscribe, setSubscribe] = useState<boolean>(true)
	const [otherDetails, setOtherDetails] = useState<string>("")
	

	return (
		<HelmetProvider>
			<BrowserRouter>
				<ScrollToTop />
				<WebsiteControlsProvider>
					<FormDataContext.Provider
						value={{
							firstName: firstName,
							setFirstName: setFirstName,
							lastName: lastName,
							setLastName: setLastName,
							email: email,
							setEmail: setEmail,
							phone: phone,
							setPhone: setPhone,
							address: address,
							setAddress: setAddress,
							county: county,
							setCounty: setCounty,
							jobDetails: jobDetails,
							setJobDetails: setJobDetails,
							referralSource: referralSource,
							setReferralSource: setReferralSource,
							referralSourceOther: referralSourceOther,
							setReferralSourceOther: setReferralSourceOther,
							subscribe: subscribe,
							setSubscribe: setSubscribe,
							otherDetails: otherDetails,
							setOtherDetails: setOtherDetails,

						}}
					>
						<div className="App">
							<Layout>
								<Routes>
									<Route path="/" element={<HomePage />} />
									{/* <Route path="/story" element={<OurStoryPage />} />
									<Route path="/services" element={<ServicesPage />} /> */}
									<Route path="/contact" element={<ContactPage />} />
									{/* <Route path="/faq" element={<FAQPage />} />
									<Route path="/team" element={<TeamPage />} /> */}
									<Route path="*" element={<NotFoundPage />} />
								</Routes>
							</Layout>
						</div>
					</FormDataContext.Provider>
				</WebsiteControlsProvider>
			</BrowserRouter>
		</HelmetProvider>
	);
}

export default App;

